<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <AudiencesHeader />
        <AudiencesList />
    </AccountViewBase>
</template>

<script>
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import AudiencesList from '@/components/account/audiences/AudiencesList';
    import AudiencesHeader from '@/components/account/audiences/AudiencesHeader';

    export default {
        name: 'AudiencesView',
        components: {
            AccountViewBase,
            AudiencesList,
            AudiencesHeader
        },
        mixins: [i18nViewMixin, accountMixin],
        data() {
            return {
                seo_title: 'views.audiences.seo_title'
            };
        }
    }
</script>